import { render, staticRenderFns } from "./StoreSettingPin.vue?vue&type=template&id=a881899a"
import script from "./StoreSettingPin.vue?vue&type=script&lang=js"
export * from "./StoreSettingPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports